import { render, staticRenderFns } from "./EditorialMainItem.vue?vue&type=template&id=08e9869c&scoped=true&"
import script from "./EditorialMainItem.vue?vue&type=script&lang=js&"
export * from "./EditorialMainItem.vue?vue&type=script&lang=js&"
import style0 from "./EditorialMainItem.vue?vue&type=style&index=0&id=08e9869c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e9869c",
  null
  
)

export default component.exports